export const block = 'tve__cta';

export default {
  block,
};
